import { ESalesType } from '../../../types/salesLink';
import { IApplicationState } from '../../../types/redux';
import { getSalesLinks } from '../getSalesLinks';

export const selectHasBlackFridaySalesLink = (state: IApplicationState): boolean => {
  const salesLinks = getSalesLinks(state);

  return salesLinks.some(salesLink => salesLink.salesType === ESalesType.BlackFriday);
};
